<template>
    <div class="bg-white p-5 shadow-md rounded-xl h-full">
        <h2 class="text-lg font-semibold text-gray-700 mb-3 flex items-center">
            <span class="mr-2">🤝</span>
            <span>Partners by Type of Collaboration</span>
        </h2>
        <div v-if="hasData" class="chart-container">
            <apexchart type="donut" height="260" :options="chartOptions" :series="chartSeries" @dataPointSelection="onSliceSelect" @click="onSliceSelect" />
        </div>
        <div v-else class="chart-empty">
            <span class="chart-empty-icon">📊</span>
            <p class="chart-empty-text">No data available</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PartnersByTypeOfCollaborationChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartOptions() {
            return {
                chart: {
                    type: 'donut',
                    toolbar: { show: false },
                },
                labels: this.data.map(item => item.type_of_collaboration),
                colors: this.getColorPalette(),
                legend: {
                    position: 'bottom',
                    formatter: (seriesName, opts) => {
                        const seriesIndex = opts.seriesIndex;
                        const value = this.chartSeries[seriesIndex];
                        return seriesName + " - " + value;
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => val + " Partners",
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%',
                        }
                    }
                }
            };
        },
        chartSeries() {
            return this.data.map(item => item.count);
        }
    },
    methods: {
        onSliceSelect: function (event, chartContext, config) {
            var index = config && typeof config.dataPointIndex === "number" ? config.dataPointIndex : -1;
            var selectedItem = this.data && index >= 0 ? this.data[index] : null;
            if (selectedItem && selectedItem.type_of_collaboration) {
                this.onTypeSegmentClick(selectedItem.type_of_collaboration);
            }
        },
        onTypeSegmentClick(type) {
            this.$emit('type-of-collaboration-clicked', type);
        },
        getColorPalette() {
            return [
                '#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6',
                '#06B6D4', '#EC4899', '#84CC16', '#F97316', '#6366F1',
                '#14B8A6', '#A855F7', '#22C55E', '#EAB308', '#06B6D4',
                '#8B5CF6', '#F43F5E', '#0EA5E9', '#10B981'
            ];
        }
    }
};
</script>

<style scoped>
.chart-container {
    cursor: pointer;
}
.chart-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 350px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #cbd5e1;
}
.chart-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0.6;
}
.chart-empty-text {
    font-size: 0.9375rem;
    color: #64748b;
}
</style>
